import { render, staticRenderFns } from "./secialffApplicationListAdmin.vue?vue&type=template&id=39f68bc4&scoped=true&"
import script from "./secialffApplicationListAdmin.vue?vue&type=script&lang=js&"
export * from "./secialffApplicationListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./secialffApplicationListAdmin.vue?vue&type=style&index=0&id=39f68bc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f68bc4",
  null
  
)

export default component.exports